module.exports = __webpack_public_path__ + "img/pdgt_kdl.90c1bcb8.jpg";